<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.question, decisionTree.context)" />
    </template>
    <template #body>
      <BaseSelect v-model="node.selectedState" :options="options" :test-id="TestId.booking.select"></BaseSelect>
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";
import { TestId } from "#/test-ids";

import { useStateStore } from "#/decision_tree_viewer/store/state";
import { computed } from "vue";
const { states } = useStateStore();

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const options = computed(() =>
  states.map((state) => ({
    label: state.name,
    value: state.id,
  })),
);

const { processText } = useSnippetProcessor();
</script>
